import React, { useState } from "react";
import styled from "styled-components";
import { Banner } from "../../components";
import {
  Switch,
  Route,
  useRouteMatch,
  useParams,
  Redirect,
} from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import Context from "../../context";
import InformasiTol from "./InformasiTol";
import TeknologiKami from "./TeknologiKami";
import LiveCctv from "./LiveCctv";
import VirtualTourTollRoad from "./VirtualTourTollRoad";

const StyledBody = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  padding-top: 16px;
  @media screen and (max-width: 500px) {
    padding-top: 32px;
  }
`;

const JalanTolKamiSub = ({ isId }: any) => {
  const { jalanTolKamiId }: any = useParams();

  if (jalanTolKamiId === "informasi-tol") {
    return <InformasiTol isId={isId} />;
  }
  if (jalanTolKamiId === "teknologi-kami") {
    return <TeknologiKami isId={isId} />;
  }
  if (jalanTolKamiId === "live-cctv") {
    return <LiveCctv isId={isId} />;
  }
  if (jalanTolKamiId === "virtual-tour-toll-road") {
    return <VirtualTourTollRoad isId={isId} />;
  }

  return <>Null</>;
};

const JalanTolKami = () => {
  const { path } = useRouteMatch();
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === "ID";
  const [jalanTolKamiState, setJalanTolKamiState] = React.useState([]);
  const [loadingState, setLoadingState] = useState(true);

  const getData = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content?type=1`
      );
      const resJson = await res.json();
      setJalanTolKamiState(resJson.data.rows);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    getData();
    // window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Banner title={isId ? "Jalan Tol Kami" : "Our Toll Road"} />
      <StyledBody>
        <StyledContent>
          {loadingState ? (
            <div
              style={{
                width: "100%",
                padding: "0 16px",
                display: "flex",
                justifyContent: "center",
                marginBottom: "4rem",
              }}
            >
              <div style={{ width: "100%", maxWidth: 1280 }}>
                <Skeleton
                  variant="rect"
                  height={42}
                  style={{ marginBottom: 16 }}
                />
                <Skeleton variant="rect" height={200} />
              </div>
            </div>
          ) : (
            <Switch>
              <Route exact path={path}>
                <Redirect to={`${path}/informasi-tol`} />
              </Route>
              <Route path={`${path}/:jalanTolKamiId`}>
                <JalanTolKamiSub isId={isId} data={jalanTolKamiState} />
              </Route>
            </Switch>
          )}
        </StyledContent>
      </StyledBody>
    </>
  );
};

export default JalanTolKami;
